












































































































import {Component, Vue, Prop, Emit, Watch} from 'vue-property-decorator';
import api from '@/infrastructure/api/api';
import {progress} from '@/script/progress';
import ConfirmDialog from '@/components/atom/dialog/ConfirmDialog.vue';
import NormalButton from '@/components/atom/button/NormalButton.vue';
import NormalDialog from '@/components/atom/dialog/NormalDialog.vue';
import {優先卸予約削除依頼型, 優先卸型, 優先卸履歴型, 優先卸更新依頼型, 優先卸予約登録依頼型} from '@/type/wholesale/primary/wholesale';
import Datepicker from '@/components/datepicker/DatePicker.vue';
import WholesaleSelector from '@/components/wholesale/WholesaleSelector.vue';
import AlertDialog from '@/components/atom/dialog/AlertDialog.vue';
import moment from 'moment';
import 優先卸予約登録チェッカー from '@/type/wholesale/primary/優先卸予約登録チェッカー';
import 優先卸更新チェッカー from '@/type/wholesale/primary/優先卸更新チェッカー';

@Component({
  components: {
    Datepicker,
    ConfirmDialog,
    NormalButton,
    NormalDialog,
    WholesaleSelector,
    AlertDialog,
  },
  filters: {
    dateFormat(value: Date): string {
      if (!value) {
        return '';
      }
      moment.locale('ja');
      return moment(value).format('YYYY/MM/DD');
    },
  },
})

export default class PrimaryWholesaleDetail extends Vue {
  // data
  優先卸履歴一覧: 優先卸履歴型[] = [];
  適用開始日: Date | null = null;
  卸コード: string | null = null;
  有効適用開始日From: Date = moment().toDate();
  有効適用開始日To: Date = moment().startOf('day').add(1, 'days').toDate();

  優先卸予約登録依頼: 優先卸予約登録依頼型 | null = null;
  優先卸更新依頼: 優先卸更新依頼型 | null = null;
  優先卸予約削除依頼: 優先卸予約削除依頼型 | null = null;

  アラートメッセージ: string | string[] | null = null;

  @Prop({default: false})
  優先卸: 優先卸型 | null = null;
  @Prop({default: false})
  modal!: boolean;

  @Emit('closeDetail')
  closeDetail(): void {
    this.clear();
    this.closeDialog('卸一括更新詳細画面');
  }

  @Watch('modal')
  changeDialog(nowModal: boolean, prevModal: boolean): void {
    if (nowModal) {
      this.init();
      this.openDialog('卸一括更新詳細画面');
    }
  }

  // computed
  get isChanged(): boolean {
    if (!this.優先卸 || !this.優先卸更新依頼) {
      return false;
    }
    return (this.優先卸.卸コード !== this.優先卸更新依頼.卸コード) ||
      (moment(this.優先卸.適用開始日).format('YYYYMMDD') !== moment(this.優先卸更新依頼.適用開始日).format('YYYYMMDD'));
  }

  get hasReservation(): boolean {
    return this.優先卸履歴一覧.some((履歴) => (履歴.ステータス区分 === '予約'));
  }

  // method
  優先卸予約登録入力エラー判定(name: string): boolean {
    if (!this.優先卸 || !this.卸コード || !this.適用開始日) {
      return false;
    }
    const checker = new 優先卸予約登録チェッカー(
      {
        商品コード: this.優先卸.商品コード,
        卸コード: this.卸コード,
        適用開始日: this.適用開始日,
      });
    return checker.hasError(name);
  }

  優先卸更新入力エラー判定(name: string): boolean {
    if (!this.優先卸更新依頼) {
      return false;
    }
    const checker = new 優先卸更新チェッカー(this.優先卸更新依頼);
    return checker.hasError(name);
  }

  openDialog(name: string): void {
    this.$modal.show(name);
  }

  closeDialog(name: string): void {
    this.$modal.hide(name);
  }

  openRegisterDialog(): void {
    if (!this.優先卸 || !this.卸コード || !this.適用開始日) {
      return;
    }
    this.優先卸予約登録依頼 = {
      商品コード: this.優先卸.商品コード,
      卸コード: this.卸コード,
      適用開始日: this.適用開始日,
    };
    this.openDialog('予約追加ダイアログ');
  }

  openUpdateDialog(): void {
    if (!this.優先卸更新依頼) {
      return;
    }
    const checker = new 優先卸更新チェッカー(this.優先卸更新依頼);
    if (checker.hasErrors()) {
      this.showAlert(checker.errorMessages());
      return;
    }
    this.openDialog('更新ダイアログ');
  }

  openDeleteDialog(優先卸履歴: 優先卸履歴型): void {
    this.優先卸予約削除依頼 = {
      商品コード: 優先卸履歴.商品コード,
    };
    this.openDialog('削除ダイアログ');
  }

  registerHandler(): void {
    progress(this.register);
    this.closeDialog('予約追加ダイアログ');
  }

  updateHandler(): void {
    progress(this.update);
    this.closeDialog('更新ダイアログ');
  }

  deleteHandler(): void {
    progress(this.delete);
    this.closeDialog('削除ダイアログ');
  }

  async 優先卸履歴一覧を取得する(): Promise<void> {
    if (!this.優先卸) {
      return;
    }
    this.優先卸履歴一覧 = await api.優先卸履歴一覧を取得する(this.優先卸.商品コード);
    const 優先卸履歴 = this.優先卸履歴一覧.find((履歴) => (履歴.ステータス区分 === '現在'));
    if (!優先卸履歴) {
      return;
    }
    this.優先卸更新依頼 = {
      商品コード: 優先卸履歴.商品コード,
      卸コード: 優先卸履歴.卸コード,
      適用開始日: 優先卸履歴.適用開始日,
    };
  }

  async register(): Promise<void> {
    if (!this.優先卸予約登録依頼) {
      return;
    }
    await api.優先卸予約を登録する(this.優先卸予約登録依頼)
      .then(
        () => {
          this.優先卸履歴一覧を取得する();
        },
        (error: any) => {
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
          if (error.data.message && !error.data.errors) {
            this.showAlert([error.data.message]);
          }
        },
      );
  }

  async update(): Promise<void> {
    if (!this.優先卸更新依頼) {
      return;
    }
    await api.優先卸を更新する(this.優先卸更新依頼)
      .then(
        () => {
          this.優先卸履歴一覧を取得する();
        },
        (error: any) => {
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
          if (error.data.message && !error.data.errors) {
            this.showAlert([error.data.message]);
          }
        },
      );
  }

  async delete(): Promise<void> {
    if (!this.優先卸予約削除依頼) {
      return;
    }
    await api.優先卸予約を削除する(this.優先卸予約削除依頼)
      .then(
        () => {
          this.優先卸履歴一覧を取得する();
        },
        (error: any) => {
          if (error.data.errors) {
            this.showAlert(error.data.errors);
          }
          if (error.data.message && !error.data.errors) {
            this.showAlert([error.data.message]);
          }
        },
      );
  }

  clear(): void {
    this.優先卸履歴一覧 = [];
    this.closeDialog('クリアダイアログ');
  }

  init(): void {
    if (!this.優先卸) {
      return;
    }
    this.適用開始日 = moment().add(1, 'days').toDate();
    this.卸コード = null;
    this.優先卸履歴一覧を取得する();
  }

  showAlert(message: string[] | string | null): void {
    this.アラートメッセージ = message;
    this.openDialog('卸一括更新詳細アラート');
  }
}
